import { Car } from "@/lib/types";
import { parseFinnSearchResults, parseFinnCar } from "./parsers";

// API URL-er
const API_BASE_URL = "https://autofox-api.mprod.workers.dev/api";
const FINN_CARS_API = `${API_BASE_URL}/finn/cars`;

// API-konfigurasjon
const ORG_ID = import.meta.env.VITE_FINN_ORG_ID;

// Sjekk at miljøvariabler er satt
if (!ORG_ID) {
  console.error("VITE_FINN_ORG_ID er ikke satt i .env filen");
}

// Definerer filtertype
interface CarFilters {
  priceRange?: string;
  fuelType?: string;
  fuelTypes?: string[];
  transmission?: string;
  transmissions?: string[];
  year?: number;
  minYear?: number;
  maxYear?: number;
  make?: string;
  makes?: string[];
  model?: string;
  minMileage?: number;
  maxMileage?: number;
}

/**
 * Henter biler fra vår egen API
 */
export const fetchCarsFromFinn = async (query: string, filters?: CarFilters): Promise<Car[]> => {
  if (!ORG_ID) {
    throw new Error("Organisasjons-ID mangler. Sett VITE_FINN_ORG_ID i .env-filen");
  }
  
  const url = `${FINN_CARS_API}?orgId=${ORG_ID}`;
  
  const response = await fetch(url, {
    headers: {
      'Accept': 'application/xml'
    }
  });
  
  if (!response.ok) {
    console.error('API Error:', {
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries())
    });
    throw new Error(`API-forespørsel feilet: ${response.status} ${response.statusText}`);
  }
  
  const xmlData = await response.text();
  return parseFinnSearchResults(xmlData);
};

/**
 * Henter en enkelt bil fra vår egen API
 */
export const fetchCarFromFinn = async (id: string): Promise<Car | null> => {
  const url = `${FINN_CARS_API}/${id}`;
  
  const response = await fetch(url, {
    headers: {
      'Accept': 'application/xml'
    }
  });
  
  if (!response.ok) {
    console.error('API Error:', {
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries())
    });
    throw new Error(`API-forespørsel feilet: ${response.status} ${response.statusText}`);
  }
  
  const xmlData = await response.text();
  return parseFinnCar(xmlData);
};

// Eksporterte API-funksjoner
export const getAllCars = async (): Promise<Car[]> => {
  return fetchCarsFromFinn("");
};

export const getCarById = async (id: string): Promise<Car | null> => {
  return fetchCarFromFinn(id);
};

export const searchCars = async (query: string, filters?: CarFilters): Promise<Car[]> => {
  return fetchCarsFromFinn(query, filters);
}; 